import { BaseActionItemProps } from './ActionItemTypes';
import { ClassSummaryActionItem } from './ClassSummaryActionItem';
import { DraftMessageActionItem } from './DraftMessageActionItem';

type ActionAccordionItemProps = BaseActionItemProps & {
  periodId: string;
  onGoToCustomMessages?: () => void;
};

export const ActionAccordionItem = ({
  type,
  title,
  studentId,
  studentVoiceName,
  actionId,
  message,
  date,
  periodId,
  meetingId,
  onGoToCustomMessages,
}: ActionAccordionItemProps) => {
  // Factory pattern - route to specific implementations
  switch (type) {
    case 'class_summary':
      return (
        <ClassSummaryActionItem
          title={title}
          type={type}
          actionId={actionId}
          message={message}
          date={date}
          periodId={periodId}
          meetingId={meetingId}
        />
      );

    case 'praised_students':
    case 'warned_students':
      return (
        <DraftMessageActionItem
          type={type}
          studentId={studentId}
          studentVoiceName={studentVoiceName}
          actionId={actionId}
          message={message}
          date={date}
          onGoToCustomMessages={onGoToCustomMessages}
        />
      );

    default:
      // Don't show anything for unknown types
      return <></>;
  }
};
